// extracted by mini-css-extract-plugin
export default {"facebook__icon":"shareIcon_facebook__icon__o7Ji5","twitter__icon":"shareIcon_twitter__icon__kSzbT","kakao__icon":"shareIcon_kakao__icon__kMjYo"};